import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stateComponent from './state.component';
import StateService from './state.service';

let stateModule = angular.module('state', [
  uiRouter
])

.service('State', StateService)

.component('state', stateComponent)

.name;

export default stateModule;



// WEBPACK FOOTER //
// ./client/app/components/state/state.js